import _classCallCheck from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { OptionsColor } from "../../OptionsColor";
export var LightGradient =
/*#__PURE__*/
function () {
  function LightGradient() {
    _classCallCheck(this, LightGradient);

    this.start = new OptionsColor();
    this.stop = new OptionsColor();
    this.start.value = "#ffffff";
    this.stop.value = "#000000";
  }

  _createClass(LightGradient, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }

      this.start = OptionsColor.create(this.start, data.start);
      this.stop = OptionsColor.create(this.stop, data.stop);
    }
  }]);

  return LightGradient;
}();